export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учет: Список ТК",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
